module.exports = __webpack_public_path__ + "static/Casablanca1-0dd8371dd0bf5489cf1daab232ddf076.jpg";